const SvgTrain = ({fill, stroke, color}) => {
    return (

        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 912.000000 1280.000000"
             preserveAspectRatio="xMidYMid meet">
            <metadata>
                Created by potrace 1.15, written by Peter Selinger 2001-2017
            </metadata>
            <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
               fill="currentColor" stroke="none">
                <path d="M4425 12794 c-11 -2 -47 -9 -80 -15 -148 -28 -224 -53 -325 -109 -19
-11 -48 -20 -65 -20 -43 0 -125 -51 -180 -112 -145 -160 -273 -430 -325 -685
-26 -126 -48 -203 -59 -203 -15 0 -83 27 -161 63 -139 64 -261 94 -424 103
-236 14 -412 -51 -579 -214 -45 -45 -61 -69 -73 -111 -12 -39 -24 -57 -45 -69
-53 -31 -83 -140 -101 -370 -9 -117 -9 -179 0 -270 19 -190 51 -260 181 -397
148 -154 165 -177 148 -186 -8 -5 -74 -22 -145 -38 -130 -29 -171 -45 -225
-85 -27 -20 -41 -21 -255 -22 -200 0 -236 -3 -304 -22 -102 -28 -172 -62 -235
-114 -29 -24 -63 -51 -77 -60 -69 -49 -356 -559 -402 -713 -28 -98 -23 -191
20 -318 56 -168 144 -341 210 -414 68 -74 139 -128 197 -148 38 -14 45 -14 65
0 13 8 28 15 35 15 19 0 139 -122 180 -183 50 -75 52 -117 8 -170 -17 -20 -28
-37 -25 -37 4 0 30 14 59 30 30 17 63 30 75 30 27 0 91 -56 107 -94 15 -35 11
-49 -44 -177 -44 -104 -55 -163 -24 -138 9 8 38 59 64 115 61 129 71 138 98
85 12 -22 25 -42 29 -45 5 -3 22 8 37 24 50 52 95 33 95 -39 0 -17 5 -31 12
-31 6 0 38 23 70 51 33 28 62 49 65 45 16 -15 -44 -154 -111 -259 -59 -91 -83
-191 -116 -474 -28 -231 -31 -237 -70 -153 -13 28 -27 50 -31 50 -4 0 -10 -15
-14 -32 -4 -19 -20 -45 -38 -60 l-31 -26 12 -71 c12 -70 9 -101 -10 -101 -22
0 -75 70 -128 170 -30 57 -60 105 -67 107 -7 3 -14 -16 -18 -54 -4 -32 -10
-71 -14 -87 l-7 -30 -26 45 c-49 83 -79 200 -113 444 -8 59 -17 47 -35 -47 -7
-37 -16 -65 -21 -62 -15 9 -10 234 6 330 31 179 82 296 141 320 22 9 34 21 34
34 0 39 -72 12 -113 -42 -64 -85 -159 -313 -197 -472 -11 -43 -21 -80 -23 -83
-9 -8 -18 137 -11 188 23 189 108 392 229 547 49 62 68 102 49 102 -25 0 -83
-54 -138 -127 -137 -183 -235 -405 -244 -553 -3 -60 1 -93 22 -164 14 -48 26
-109 26 -135 0 -86 -61 -142 -116 -106 -77 50 -115 271 -94 544 24 313 36 351
164 494 145 163 158 187 97 187 -31 0 -101 -42 -151 -91 -19 -19 -73 -84 -119
-144 -98 -127 -126 -194 -167 -394 -34 -165 -30 -221 19 -325 49 -104 48 -130
-8 -203 -96 -123 -145 -197 -164 -247 -54 -145 -56 -473 -3 -546 31 -42 131
-117 211 -159 85 -44 184 -79 312 -111 l86 -22 6 -336 c11 -678 -16 -911 -153
-1337 -38 -118 -76 -251 -85 -297 -36 -189 -38 -624 -5 -835 35 -220 101 -370
218 -494 171 -182 504 -352 812 -413 180 -37 224 -62 197 -117 l-13 -24 -354
-6 c-636 -12 -1321 -40 -1475 -60 -160 -21 -185 -38 -185 -126 0 -56 17 -83
52 -83 11 0 225 31 476 69 698 106 873 125 1104 119 162 -3 189 -12 152 -49
-32 -32 -115 -48 -299 -59 -283 -17 -501 -44 -475 -60 7 -4 155 -5 330 -2 174
3 329 2 344 -2 67 -17 6 -36 -174 -56 -260 -28 -525 -75 -825 -144 -185 -42
-384 -77 -505 -87 -115 -9 -180 -23 -180 -39 0 -28 15 -40 48 -40 85 0 708
103 815 135 146 43 957 87 1018 55 71 -38 -33 -61 -486 -105 -427 -41 -589
-66 -800 -121 -71 -18 -224 -54 -340 -80 -218 -48 -268 -63 -205 -64 84 0 669
95 990 161 176 37 213 41 380 45 172 4 183 4 151 -11 -103 -47 -255 -83 -576
-136 -132 -21 -352 -69 -618 -134 -81 -19 -195 -43 -252 -53 -235 -38 -23 -49
236 -12 210 30 393 66 511 100 128 37 261 60 353 60 122 0 146 -17 71 -51 -85
-37 -657 -175 -971 -234 -177 -33 -175 -33 -151 -51 11 -8 42 -14 71 -14 105
0 390 42 655 97 194 41 265 47 265 23 0 -22 -56 -45 -179 -75 -150 -36 -236
-64 -236 -75 0 -13 44 -13 220 1 157 12 200 6 200 -30 0 -29 -24 -43 -63 -36
-19 4 -61 1 -93 -5 -59 -12 -242 -76 -257 -89 -4 -4 36 -2 90 5 54 7 120 13
146 14 113 0 3 -51 -213 -100 -139 -32 -214 -55 -247 -76 -57 -36 0 -50 117
-29 153 28 292 45 359 45 56 0 63 -2 51 -14 -20 -18 -95 -42 -215 -66 -110
-23 -170 -47 -170 -70 0 -12 17 -15 89 -15 l90 0 7 -33 c4 -18 9 -36 13 -39 8
-8 48 -8 178 2 96 7 108 6 114 -9 10 -25 -13 -45 -71 -62 -30 -8 -59 -22 -66
-31 -21 -24 24 -56 68 -48 43 8 69 -7 76 -44 9 -42 43 -69 107 -87 97 -27 136
-44 158 -69 27 -31 41 -31 101 -1 100 51 298 101 616 155 512 87 744 105 1705
132 601 18 2022 18 2275 0 212 -14 265 -23 205 -34 -19 -4 -165 -23 -324 -42
-289 -35 -400 -56 -433 -80 -51 -38 64 -42 469 -20 439 25 1142 25 1490 0 261
-19 323 -16 323 15 0 22 -57 49 -138 65 -41 8 -178 24 -303 35 -294 27 -414
47 -414 70 0 14 59 20 265 26 224 8 501 -8 592 -33 101 -27 127 -32 135 -26
15 8 -12 32 -76 68 -34 20 -70 43 -82 53 -30 25 -57 70 -49 82 18 30 189 -7
342 -74 105 -46 154 -48 106 -3 -71 64 -287 128 -436 130 -113 1 -134 -9 -87
-43 23 -16 29 -25 20 -34 -16 -16 -476 -22 -515 -6 l-30 12 35 16 c19 8 96 20
170 26 l135 10 -90 8 c-120 11 -189 28 -193 50 -6 29 61 40 286 45 322 8 524
-15 785 -88 60 -17 115 -28 123 -25 39 15 -49 87 -156 127 -122 46 -250 57
-757 68 -200 4 -366 11 -370 14 -30 31 107 48 437 54 435 8 709 -11 905 -62
122 -31 162 -38 170 -26 12 21 -121 82 -262 120 -205 55 -317 65 -758 66 -225
1 -423 3 -440 4 l-30 3 30 13 c65 28 217 39 535 39 518 -1 920 -44 1066 -114
73 -35 85 -36 109 -10 15 17 16 22 4 36 -33 41 -246 109 -437 141 -95 16 -181
18 -762 18 -734 1 -760 1 -760 14 0 18 166 42 415 61 77 5 164 12 193 15 165
16 607 24 779 15 279 -15 411 -38 608 -106 55 -19 111 -33 125 -32 31 4 38 39
16 73 -60 92 -297 110 -1281 101 -374 -3 -727 -10 -785 -15 -58 -6 -138 -13
-179 -17 -61 -6 -73 -5 -69 7 7 21 64 45 151 63 42 8 98 25 123 37 40 18 76
22 253 29 208 9 271 16 271 31 0 17 -133 22 -490 16 -206 -4 -391 -3 -410 2
l-35 8 30 12 c163 67 765 123 1450 136 472 9 713 24 700 45 -21 34 -1581 9
-2035 -32 -181 -16 -205 -16 -205 1 0 43 237 75 755 101 165 8 1426 50 1520
50 15 0 20 4 15 9 -27 27 -980 77 -1275 67 -308 -10 -1020 -76 -1123 -103 -53
-14 -60 -15 -74 0 -14 14 -13 17 10 31 13 9 62 23 108 32 46 8 143 26 214 39
127 24 254 34 1180 95 394 27 603 56 577 82 -7 7 -69 6 -193 -1 -278 -17
-1008 -41 -1234 -40 -145 0 -225 5 -290 17 l-90 17 280 18 c338 20 682 51 864
77 123 18 151 25 140 33 -6 5 -605 -11 -879 -23 -135 -6 -382 -24 -550 -40
-530 -52 -627 -55 -637 -23 -6 17 24 41 65 53 68 20 255 39 572 60 331 21 751
58 759 65 7 7 -260 5 -544 -4 -263 -9 -422 -1 -482 24 -19 8 -33 20 -31 27 9
26 101 39 393 55 306 18 347 31 100 33 -66 0 -195 5 -287 10 -204 13 -210 11
-323 -100 -94 -91 -113 -98 -231 -80 -111 17 -184 46 -184 72 0 28 82 234 132
331 55 105 82 127 162 127 79 0 106 -17 106 -68 -1 -91 -65 -162 -147 -162
-47 0 -89 -16 -97 -36 -13 -34 108 -118 161 -112 24 3 34 16 79 109 50 102
103 167 126 153 6 -4 7 -31 3 -70 -7 -62 -7 -64 20 -74 62 -24 293 -6 324 25
13 13 10 16 -22 30 -20 8 -69 15 -109 16 -40 1 -84 4 -98 8 -22 6 -20 8 24 20
70 17 106 38 106 61 0 27 -17 34 -83 33 -60 -2 -107 9 -107 26 0 19 30 38 69
45 23 3 41 11 41 16 0 21 -54 30 -167 30 -64 0 -114 3 -111 6 4 3 42 15 85 26
110 28 173 56 173 78 0 22 -32 34 -134 51 -42 6 -75 14 -73 16 2 2 37 13 77
24 105 29 222 108 351 238 107 107 147 156 136 168 -9 9 -51 -21 -141 -101
-167 -147 -267 -218 -280 -197 -8 13 44 88 135 191 165 190 257 332 344 535
56 131 128 361 149 475 41 226 74 596 82 920 5 217 -1 315 -21 315 -17 0 -25
-70 -35 -327 -5 -141 -14 -274 -19 -295 -6 -21 -15 -56 -20 -78 -6 -22 -11
-71 -11 -110 -1 -287 -77 -630 -204 -914 -67 -151 -171 -330 -246 -424 -141
-176 -424 -379 -644 -462 -147 -55 -316 -73 -316 -33 0 5 31 40 68 76 76 74
141 191 149 267 9 78 -8 71 -120 -54 -60 -67 -86 -53 -102 53 -4 21 -10 35
-14 30 -5 -5 -19 -52 -31 -104 -27 -112 -58 -200 -71 -200 -16 0 -22 52 -13
124 11 88 7 126 -12 126 -22 0 -41 -54 -64 -181 -23 -133 -47 -219 -59 -219
-15 0 -19 35 -14 126 5 98 -4 126 -34 108 -20 -13 -33 -45 -63 -159 -23 -90
-54 -140 -69 -115 -6 8 -9 58 -8 112 1 66 -2 101 -10 109 -23 23 -36 -7 -44
-107 -8 -97 -31 -188 -51 -200 -17 -11 -28 18 -28 74 0 28 -4 52 -8 52 -4 0
-19 -21 -32 -47 l-24 -48 -8 74 c-10 99 -33 125 -73 81 -13 -14 -17 -35 -17
-77 1 -72 -8 -82 -58 -76 -44 6 -43 8 -55 -92 -7 -55 -39 -135 -53 -135 -16 0
-22 28 -22 103 0 82 -16 150 -33 144 -25 -8 -40 -66 -51 -196 -10 -116 -13
-130 -19 -91 -21 126 -46 200 -68 200 -15 0 -26 -38 -32 -122 -7 -81 -35 -179
-53 -185 -12 -4 -24 80 -25 186 -1 82 -3 76 -38 -96 -28 -139 -61 -233 -81
-233 -17 0 -30 46 -31 108 0 31 -4 77 -8 102 l-8 45 -22 -47 c-12 -26 -27 -91
-35 -150 -7 -57 -21 -120 -30 -141 -19 -46 -54 -97 -66 -97 -5 0 -9 53 -8 118
2 83 -2 124 -11 141 -13 23 -15 23 -26 7 -8 -10 -16 -57 -19 -104 -9 -118 -24
-192 -43 -199 -25 -10 -33 18 -33 127 0 58 -3 115 -6 128 -14 49 -29 11 -42
-98 -8 -79 -20 -130 -37 -168 -38 -82 -51 -66 -47 60 2 83 0 107 -12 117 -26
22 -47 -28 -56 -131 -8 -97 -20 -141 -41 -154 -17 -10 -39 24 -39 61 0 31 -24
75 -40 75 -19 0 -34 -48 -41 -135 -8 -96 -41 -203 -66 -212 -30 -12 -38 13
-25 87 12 72 9 100 -13 100 -20 0 -41 -65 -65 -196 -21 -118 -44 -185 -67
-192 -22 -6 -26 49 -13 158 16 138 1 190 -34 122 -14 -27 -21 -60 -61 -276
-31 -172 -58 -163 -53 17 3 98 1 112 -14 115 -26 5 -47 -47 -57 -147 -10 -96
-40 -181 -64 -181 -23 0 -28 26 -21 110 4 43 4 86 0 96 -6 16 -8 16 -25 0 -18
-17 -36 -69 -71 -216 -20 -87 -46 -135 -71 -135 -10 0 -14 12 -12 40 6 140 4
197 -7 229 -6 20 -15 36 -19 36 -11 0 -21 -62 -21 -130 0 -120 -46 -310 -72
-294 -4 3 -8 66 -8 140 0 74 -4 134 -8 134 -4 0 -19 -33 -32 -72 l-23 -73 -22
70 c-65 209 -111 172 -103 -82 3 -100 8 -137 21 -157 9 -14 17 -32 17 -40 0
-18 -67 -66 -91 -66 -23 0 -29 20 -30 108 -1 103 -18 167 -44 167 -23 0 -28
-21 -44 -172 -10 -97 -38 -194 -58 -200 -5 -2 -19 18 -31 43 -22 44 -24 45
-41 30 -10 -10 -31 -44 -46 -77 -29 -64 -36 -134 -22 -204 l9 -40 -51 52 c-61
61 -63 79 -27 200 30 99 42 188 27 197 -6 4 -17 -16 -26 -51 -35 -126 -49
-159 -81 -190 -17 -18 -40 -33 -49 -33 -18 0 -18 14 1 140 8 58 0 49 -66 -65
-59 -102 -104 -210 -97 -237 9 -33 -21 -43 -122 -43 -53 1 -113 7 -134 14 -44
15 -77 60 -77 107 0 36 -16 60 -50 77 -37 19 -32 49 12 70 47 23 71 56 97 135
21 61 28 142 13 142 -15 0 -32 -24 -32 -44 -1 -53 -85 -180 -101 -154 -19 29
-1 257 22 284 6 8 26 14 44 14 21 0 45 10 65 26 17 15 33 25 35 23 2 -2 -2
-23 -8 -47 -9 -32 -8 -45 1 -54 20 -20 46 3 57 50 13 53 18 56 40 31 36 -39
23 -90 -66 -266 -73 -144 -82 -168 -83 -220 -1 -43 2 -58 13 -58 24 0 50 46
116 208 96 234 143 297 133 179 -8 -90 19 -130 67 -98 51 33 65 222 26 346
-28 89 -27 123 7 159 53 57 238 193 325 238 57 29 99 59 119 84 22 27 40 39
69 44 24 4 55 21 84 47 26 23 95 69 153 104 176 103 239 146 250 168 6 14 26
27 52 35 59 17 196 99 478 283 290 189 466 296 501 305 97 24 623 314 676 373
25 27 14 37 -101 95 -68 34 -102 57 -113 77 -9 17 -37 39 -67 53 -64 30 -135
107 -191 206 -43 75 -64 139 -46 139 22 0 107 -67 261 -204 184 -164 289 -239
366 -261 61 -18 88 -12 126 30 34 36 97 70 285 155 319 144 475 230 475 262 0
7 -21 9 -57 6 -70 -7 -245 -72 -480 -179 -95 -44 -176 -79 -180 -78 -17 1
-158 234 -194 322 -20 51 -53 154 -73 229 -36 142 -60 203 -76 193 -16 -10
-11 -105 10 -191 29 -124 84 -251 171 -397 44 -72 79 -139 79 -148 0 -9 -7
-22 -15 -29 -25 -21 -91 52 -215 235 -97 144 -140 200 -140 181 0 -10 54 -116
127 -249 71 -130 109 -225 95 -239 -17 -17 -66 13 -141 90 -107 109 -139 168
-166 305 -3 17 -15 31 -30 37 -29 11 -45 39 -45 79 0 40 -11 39 -44 -4 -15
-19 -31 -35 -36 -35 -5 0 -21 22 -35 49 -85 169 -107 490 -54 801 24 145 56
247 131 420 49 115 66 142 203 319 162 210 262 322 340 384 176 137 470 436
623 630 37 47 89 127 116 177 27 50 54 89 60 87 13 -4 24 -41 25 -84 1 -18 5
-33 9 -33 5 0 22 28 38 61 25 54 29 73 29 153 0 50 -6 136 -12 191 -18 141
-39 450 -60 875 -20 419 -27 408 -37 -60 -9 -398 -23 -733 -37 -845 -13 -110
-44 -206 -105 -328 -86 -170 -105 -193 -543 -642 -430 -441 -543 -584 -720
-910 -51 -93 -96 -174 -101 -178 -15 -16 -23 183 -11 264 47 309 278 763 738
1453 265 397 348 574 428 921 55 237 94 384 112 418 8 16 32 98 53 181 38 153
68 228 139 348 21 36 45 83 52 103 22 59 37 65 69 25 26 -32 29 -33 35 -15 11
35 22 50 37 53 26 5 38 -74 48 -306 17 -391 75 -812 153 -1107 30 -114 31
-129 31 -305 -1 -156 -4 -197 -22 -262 -40 -146 -110 -247 -298 -428 -127
-123 -230 -195 -300 -210 -95 -21 -150 -59 -409 -280 -208 -177 -227 -197
-272 -285 -20 -38 -67 -119 -106 -180 -87 -135 -149 -255 -177 -343 -12 -37
-35 -84 -52 -106 -35 -44 -52 -126 -26 -126 22 0 66 37 82 68 8 15 21 55 30
89 18 72 57 152 128 267 146 234 380 522 501 618 22 18 58 35 85 40 25 4 58
19 72 32 35 32 63 46 98 46 41 0 89 36 250 183 217 198 372 363 410 434 113
214 106 500 -28 1078 -22 94 -44 199 -50 235 -33 216 -40 874 -10 935 17 34
50 44 70 20 11 -13 10 -29 -6 -98 -25 -109 -23 -182 15 -505 47 -407 95 -651
146 -737 55 -95 84 -262 92 -535 6 -198 -6 -400 -31 -532 -7 -37 -9 -65 -4
-62 12 8 65 127 89 203 30 93 37 324 15 477 -18 122 -68 336 -121 515 -112
380 -129 495 -130 869 0 343 -1 336 101 549 115 239 220 398 287 432 21 11 41
19 43 17 2 -2 -26 -51 -62 -109 -117 -185 -194 -369 -156 -369 11 0 74 103
157 255 22 41 66 97 105 136 78 77 242 189 329 224 61 25 143 33 170 16 33
-21 -21 -67 -114 -97 -88 -29 -143 -63 -216 -131 -150 -142 -262 -353 -304
-576 -16 -86 -21 -277 -6 -262 5 6 23 75 41 155 50 227 128 438 196 527 30 39
54 43 54 9 0 -38 -46 -204 -80 -291 -65 -163 -63 -149 -57 -300 6 -143 21
-251 82 -571 44 -233 70 -416 90 -629 19 -205 34 -279 57 -283 67 -13 59 223
-23 683 -119 675 -128 922 -39 1168 93 256 321 494 445 463 36 -9 72 -87 102
-224 27 -125 47 -176 66 -169 34 11 11 234 -40 388 -55 169 -164 227 -407 216
-137 -6 -258 -36 -361 -90 -92 -49 -199 -162 -264 -281 -60 -108 -95 -156
-116 -156 -24 0 -38 68 -32 149 16 201 169 504 353 700 186 198 350 272 569
258 130 -9 234 -39 363 -103 127 -64 226 -147 237 -199 13 -60 41 -110 92
-162 31 -33 60 -53 73 -53 21 0 22 4 18 45 -7 59 -64 177 -146 300 -151 228
-264 291 -547 302 -165 6 -277 -10 -395 -60 -175 -73 -435 -285 -459 -375 -7
-25 -30 -63 -56 -92 -86 -97 -111 -170 -165 -480 -17 -102 -32 -186 -33 -187
-1 -1 -45 -9 -97 -17 -153 -26 -218 -57 -190 -91 10 -12 26 -14 76 -9 96 10
94 3 -57 -182 -97 -119 -230 -316 -267 -394 -76 -162 -145 -404 -227 -788 -65
-305 -228 -672 -299 -672 -22 0 -21 6 29 153 55 157 99 331 155 602 91 442
114 545 147 654 59 197 126 317 255 456 57 61 108 131 108 146 0 19 -49 8 -86
-20 -85 -62 -212 -218 -267 -326 -68 -136 -165 -525 -202 -804 -18 -139 -82
-372 -190 -697 -170 -511 -296 -774 -510 -1060 -199 -266 -292 -535 -335 -964
-35 -359 -14 -990 45 -1298 53 -277 147 -425 325 -510 47 -22 103 -48 124 -57
l40 -16 -67 -44 c-84 -57 -178 -105 -205 -105 -48 0 -195 90 -549 335 -154
107 -195 106 -280 -8 -94 -127 -172 -327 -173 -443 0 -23 -3 -55 -6 -70 l-6
-29 -76 3 c-231 9 -413 89 -559 245 -102 110 -226 388 -267 602 -26 135 -36
353 -46 1020 -17 1152 -21 1242 -66 1500 -52 289 -43 471 32 687 77 222 149
334 268 423 85 62 94 73 72 81 -61 23 -193 -47 -271 -144 -86 -107 -175 -325
-175 -429 0 -89 -42 -88 -84 2 -49 102 -70 214 -69 375 0 419 178 710 522 855
155 65 315 83 400 45 24 -11 56 -20 72 -20 44 0 37 30 -21 83 -67 62 -66 80
10 234 92 187 179 269 326 307 33 9 134 22 224 31 90 8 164 16 166 18 5 4
-103 80 -143 101 -18 9 -44 16 -59 16 -66 0 -377 -129 -453 -188 -61 -47 -73
-52 -101 -37 -27 15 -68 63 -93 110 -26 51 -40 188 -34 324 7 155 25 218 72
260 52 46 97 54 260 45 154 -7 169 -3 145 42 -21 38 -80 72 -150 86 -84 17
-90 37 -29 103 55 59 99 82 191 96 82 13 257 7 303 -10 17 -7 57 -41 91 -76
55 -59 94 -82 94 -55 0 21 -39 86 -79 132 -78 88 -175 110 -391 89 -154 -16
-184 -25 -236 -73 -131 -121 -351 -467 -398 -627 -13 -44 -14 -66 -5 -119 23
-145 104 -295 195 -363 30 -22 54 -44 54 -48 0 -5 -11 -31 -24 -58 -14 -26
-32 -86 -40 -133 -20 -101 -38 -125 -110 -139 -178 -36 -219 -47 -294 -77 -45
-19 -89 -34 -97 -34 -27 0 -109 47 -142 82 -44 46 -54 77 -62 203 -7 102 -8
108 -20 80 -7 -16 -18 -58 -24 -93 -10 -56 -9 -74 11 -150 12 -48 22 -97 22
-109 0 -62 -70 43 -89 135 -18 88 -14 257 9 346 12 43 20 80 18 81 -7 7 -91
-125 -106 -166 -11 -31 -18 -93 -21 -214 l-6 -170 -30 85 c-27 77 -30 96 -30
210 1 142 22 231 75 310 34 51 26 73 -15 46 -52 -34 -97 -165 -136 -389 -6
-37 -19 -77 -29 -89 l-17 -22 -14 25 c-24 44 -24 221 0 324 35 147 166 398
237 454 59 46 81 14 93 -136 10 -128 30 -183 85 -231 65 -57 71 -31 25 108
-25 76 -32 118 -36 210 -6 130 7 201 56 305 25 54 138 211 146 203 2 -2 -10
-64 -25 -138 -82 -384 -76 -644 16 -705 31 -20 32 -5 2 61 -59 135 -19 511 73
672 83 145 160 203 375 288 156 60 181 75 169 94 -13 20 -115 3 -238 -41 -118
-42 -146 -44 -127 -8 12 22 7 49 -9 49 -17 0 -72 -62 -113 -126 -68 -108 -128
-140 -128 -68 0 32 -7 30 -46 -13 -33 -37 -34 -38 -50 -18 -35 44 6 211 83
338 50 83 158 194 249 257 126 87 298 149 311 112 8 -20 -65 -83 -147 -127
-83 -45 -232 -180 -307 -279 -56 -75 -96 -157 -83 -170 14 -14 51 24 114 114
105 149 243 253 370 280 29 6 91 10 137 8 l84 -3 -161 -83 c-88 -45 -176 -96
-195 -113 l-34 -30 29 6 c17 3 59 24 95 45 92 54 150 63 341 54 138 -6 160 -5
165 8 4 9 -4 49 -17 89 -30 97 -32 307 -4 409 34 125 150 340 182 340 21 0 18
-20 -25 -148 -50 -150 -65 -250 -66 -442 0 -154 8 -230 24 -230 18 0 23 41 31
260 6 143 15 247 25 285 20 80 99 239 176 353 107 160 239 286 239 227 0 -20
-30 -79 -77 -153 -38 -59 -32 -58 44 10 62 56 163 128 179 128 36 0 1 -71
-106 -215 -37 -49 -82 -113 -99 -141 -32 -54 -50 -114 -34 -114 15 0 37 29 80
105 22 39 62 98 89 132 92 114 177 291 198 413 l6 35 -28 -30 c-15 -17 -46
-53 -69 -80 -23 -27 -44 -47 -47 -44 -7 7 50 272 71 326 8 23 42 73 74 110 61
71 118 163 99 163 -6 0 -38 -28 -73 -62 -64 -65 -129 -174 -161 -273 -19 -59
-51 -115 -66 -115 -15 0 -36 54 -46 115 -7 47 -8 48 -15 20 -4 -16 -7 -50 -8
-75 -1 -54 -26 -97 -46 -80 -23 19 -27 87 -14 211 6 66 9 122 6 125 -3 3 -19
-4 -35 -16 -42 -31 -108 -25 -136 13 -18 25 -21 42 -20 135 1 256 134 536 353
745 177 169 392 247 646 234 176 -9 361 -64 482 -143 76 -50 331 -306 411
-413 35 -46 66 -97 69 -113 7 -34 27 -46 48 -28 35 29 9 191 -57 365 -37 95
-60 132 -131 204 -123 126 -356 247 -652 338 -76 23 -215 38 -260 27z m-1186
-1179 c91 -21 128 -54 184 -162 60 -117 117 -256 117 -287 0 -30 -5 -35 -121
-116 -127 -89 -301 -257 -334 -324 -52 -107 -100 -378 -93 -531 2 -65 7 -86
26 -109 12 -16 22 -34 22 -40 0 -15 -37 -56 -51 -56 -18 0 -128 111 -179 180
-103 140 -138 264 -88 317 12 13 27 23 34 23 7 0 16 5 19 10 10 16 -45 1 -76
-21 -14 -10 -43 -47 -64 -83 -42 -72 -63 -87 -83 -59 -26 36 8 145 72 232 20
26 40 60 45 74 9 24 8 27 -11 27 -52 0 -132 -131 -150 -246 -6 -38 -18 -77
-26 -87 -14 -16 -17 -16 -31 -2 -12 12 -16 36 -15 98 1 141 22 176 180 308
133 111 145 129 85 129 -102 0 -272 -175 -316 -325 -24 -79 -50 -115 -84 -115
-37 0 -73 41 -117 135 -52 108 -67 182 -62 304 3 97 6 110 33 154 17 27 40 65
51 84 12 19 24 56 28 81 17 125 154 245 383 336 82 33 211 67 298 79 78 11
260 6 324 -8z m191 -740 c18 -22 4 -62 -28 -79 -34 -17 -117 -105 -161 -169
-55 -81 -110 -210 -141 -332 -34 -132 -38 -141 -54 -125 -17 17 -11 117 13
205 28 102 115 283 183 382 77 111 153 160 188 118z m-1045 -794 c8 -13 -97
-85 -244 -167 -74 -41 -143 -88 -171 -117 -51 -51 -104 -77 -122 -59 -27 27
102 173 227 256 100 67 289 120 310 87z m-665 -180 c21 -6 12 -11 -60 -35
-202 -67 -386 -190 -505 -339 -80 -100 -139 -213 -195 -372 -68 -192 -98 -251
-118 -231 -12 13 20 184 55 289 64 193 172 356 346 524 108 103 166 139 257
159 60 13 181 16 220 5z m430 -86 c0 -33 -40 -138 -80 -208 -17 -31 -63 -92
-102 -134 -119 -131 -149 -207 -157 -399 -6 -151 -16 -183 -52 -164 -68 37
-42 357 46 545 72 155 296 414 337 389 4 -3 8 -16 8 -29z m-404 -77 c12 -19
-41 -55 -92 -63 -88 -13 -192 -80 -323 -208 -69 -67 -151 -176 -151 -201 0
-33 -25 -91 -51 -120 -47 -54 -60 -99 -70 -245 -10 -146 -22 -201 -45 -201
-51 0 -31 265 37 475 19 59 46 115 79 163 27 41 50 82 50 93 0 43 176 186 318
258 98 49 232 76 248 49z m-66 -172 c0 -8 -30 -35 -67 -60 -38 -24 -104 -75
-148 -112 -129 -108 -165 -125 -165 -77 0 34 65 97 176 169 128 84 204 113
204 80z m-15 -146 c11 -17 -39 -89 -129 -188 -111 -121 -131 -164 -156 -329
-11 -73 -26 -149 -35 -169 -36 -88 -65 14 -47 170 27 236 123 398 302 505 39
23 56 26 65 11z m363 -83 c7 -60 -67 -264 -109 -303 -26 -24 -53 -8 -57 33 -7
72 115 312 152 300 6 -2 12 -16 14 -30z m-748 -113 c0 -9 -7 -39 -14 -67 -19
-68 -43 -257 -58 -462 -7 -99 -15 -162 -21 -156 -5 5 -11 101 -14 212 -4 161
-2 225 11 303 20 121 46 186 75 186 13 0 21 -7 21 -16z m354 -196 c42 -67 61
-234 31 -274 -15 -19 -15 -19 -30 1 -25 32 -36 84 -42 193 -5 89 -4 102 10
102 9 0 23 -10 31 -22z m-124 -110 c26 -42 67 -171 76 -238 6 -47 5 -52 -12
-48 -47 9 -124 159 -124 243 0 81 25 99 60 43z m-49 -403 c54 -38 99 -106 99
-150 0 -36 -30 -108 -51 -120 -16 -11 -55 31 -78 84 -23 55 -42 160 -34 190 7
27 19 26 64 -4z m-712 -1573 c11 -16 35 -62 54 -103 18 -41 42 -81 51 -89 20
-16 22 -14 108 90 73 90 75 7 3 -185 -47 -124 -65 -210 -65 -310 0 -91 -14
-155 -34 -155 -24 0 -37 60 -42 190 -6 157 -13 210 -25 210 -22 0 -42 -82 -55
-224 -13 -152 -23 -183 -56 -171 -9 4 -19 21 -22 39 -3 18 -21 54 -39 81 -17
26 -40 60 -49 74 -22 32 -23 95 -3 221 27 173 54 272 87 328 25 41 59 43 87 4z
m415 -108 c11 -30 6 -130 -10 -185 -9 -30 -31 -82 -50 -116 -48 -86 -46 -128
12 -268 39 -94 94 -241 94 -252 0 -14 -29 6 -84 58 -41 38 -76 82 -93 117 -26
53 -28 65 -28 182 1 218 74 480 134 480 10 0 22 -7 25 -16z m167 -198 c45 -42
73 -59 117 -71 172 -49 192 -57 257 -105 42 -31 78 -50 95 -50 15 0 34 -8 44
-19 26 -28 56 -125 56 -180 0 -41 6 -57 34 -94 106 -139 112 -209 121 -1327 3
-415 10 -844 15 -952 9 -185 12 -203 44 -300 19 -57 50 -162 69 -233 42 -156
93 -279 176 -418 63 -107 71 -127 48 -127 -57 0 -173 153 -275 362 -121 245
-141 354 -173 917 -16 271 -29 250 -36 -59 -6 -240 6 -389 48 -593 44 -215 82
-298 224 -483 158 -206 175 -234 143 -234 -23 0 -167 102 -212 150 -59 63
-141 191 -200 310 -50 101 -73 137 -81 128 -9 -9 27 -113 100 -283 87 -204 91
-215 73 -215 -28 0 -106 59 -136 102 -130 189 -216 589 -197 918 8 137 19 192
45 228 10 15 24 54 29 87 30 175 75 1390 70 1865 -4 276 -5 297 -25 330 -11
19 -24 34 -30 33 -5 -2 -11 -34 -14 -72 -5 -74 -25 -109 -54 -98 -8 3 -32 30
-53 59 l-38 52 -7 -39 c-4 -22 -7 -55 -7 -73 -1 -43 -12 -35 -51 36 -34 59
-68 102 -82 102 -17 0 -7 -82 17 -137 39 -87 14 -114 -44 -48 -42 48 -61 120
-70 257 -4 65 -10 121 -14 125 -11 10 -54 -45 -68 -86 -7 -19 -9 -56 -5 -90
17 -159 18 -188 7 -196 -17 -10 -51 23 -72 70 -39 87 -50 358 -19 440 14 38
39 65 58 65 8 0 41 -25 73 -54z m410 -733 c15 -18 16 -206 1 -273 -7 -31 -10
-22 -30 80 -25 128 -27 162 -12 191 13 23 23 24 41 2z m-469 -23 c90 -60 158
-154 131 -181 -7 -7 -23 6 -49 40 -22 28 -43 50 -48 51 -15 0 1 -181 25 -285
l24 -100 7 45 c3 25 7 68 7 95 1 59 15 89 31 65 20 -30 41 -117 52 -215 14
-127 5 -520 -17 -710 -8 -77 -22 -207 -31 -290 -17 -175 -30 -678 -16 -655 5
8 12 49 16 90 3 41 32 278 63 525 54 431 56 460 57 685 0 249 -11 382 -50 599
-25 143 -30 206 -15 216 5 3 27 -17 48 -44 43 -56 53 -62 53 -27 0 37 12 86
21 86 21 0 80 -253 116 -495 26 -172 25 -690 0 -890 -38 -289 -66 -415 -94
-415 -20 0 -16 65 22 364 54 433 52 873 -7 1144 -26 119 -31 50 -24 -320 8
-433 0 -598 -45 -907 -28 -189 -32 -244 -33 -436 -1 -249 5 -286 81 -535 101
-332 91 -393 -27 -158 -72 143 -112 198 -145 198 -32 0 -61 40 -85 118 -43
138 -52 233 -57 572 -3 179 -8 329 -12 333 -4 4 -18 -27 -31 -70 -28 -97 -31
-102 -43 -72 -13 31 -22 1106 -12 1395 8 243 6 238 87 184z m-193 -1548 c6
-11 14 -54 20 -96 5 -43 16 -85 25 -95 21 -23 42 -109 56 -227 45 -379 91
-525 228 -734 104 -158 506 -533 599 -559 52 -15 209 -29 453 -41 200 -10 300
-25 307 -47 7 -19 -30 -24 -243 -33 -241 -11 -280 -20 -397 -97 -47 -31 -74
-57 -88 -85 l-21 -41 -66 6 c-83 6 -279 65 -391 118 -120 56 -266 156 -365
250 -100 95 -123 128 -142 210 -8 34 -28 93 -45 132 -55 125 -63 194 -63 567
0 345 11 492 48 655 17 71 47 135 66 135 5 0 14 -8 19 -18z m516 -342 c7 -34
-2 -73 -16 -65 -12 8 -12 95 0 95 5 0 12 -13 16 -30z m1838 -846 c23 -15 98
-71 167 -124 142 -111 252 -184 328 -219 28 -14 52 -28 52 -32 0 -9 -76 -70
-135 -108 -89 -56 -165 -37 -165 44 0 16 -4 37 -10 45 -7 12 -10 11 -16 -5
-21 -63 -65 -145 -83 -154 -30 -16 -44 17 -51 119 l-5 85 -28 -77 c-43 -116
-82 -155 -107 -109 -5 11 -10 71 -10 133 0 200 -25 182 -87 -66 -10 -38 -23
-71 -29 -73 -6 -2 -23 23 -37 55 -35 77 -35 134 -1 220 54 137 142 292 165
292 5 0 28 -12 52 -26z m2246 -529 c-8 -7 -170 -63 -249 -84 -75 -21 -180 -28
-180 -12 0 11 67 57 105 71 17 7 48 15 70 20 42 8 262 13 254 5z m69 -112 c2
-12 -11 -49 -28 -83 -18 -35 -37 -97 -45 -142 -14 -78 -39 -138 -61 -145 -6
-2 -17 10 -24 26 -20 50 -43 64 -92 57 -37 -6 -49 -3 -78 19 -30 22 -42 25
-78 20 -58 -9 -122 14 -200 72 -75 56 -77 54 88 78 134 20 269 54 377 95 92
34 136 36 141 3z m-2524 -68 c34 -35 27 -85 -13 -85 -27 0 -61 30 -61 54 0 43
44 61 74 31z m-350 -35 c42 -51 48 -167 10 -224 -22 -35 -24 -31 -59 111 -23
93 -26 115 -15 127 19 23 35 20 64 -14z m190 9 c20 -16 26 -29 26 -60 0 -44
-21 -93 -43 -102 -19 -7 -37 12 -37 39 0 12 -7 41 -15 64 -18 52 -18 45 1 64
21 21 36 20 68 -5z m-509 -15 c32 -21 61 -69 69 -115 8 -43 50 -89 67 -72 8 8
8 29 0 75 -15 87 -14 131 2 126 27 -9 42 -63 42 -158 0 -86 -3 -100 -29 -146
-17 -32 -41 -59 -62 -70 -34 -18 -35 -18 -77 4 -23 12 -45 22 -49 22 -3 0 -9
-19 -13 -42 -10 -58 -39 -112 -72 -136 -94 -66 -221 -50 -262 33 -26 52 -44
139 -44 210 0 113 40 183 134 230 89 46 149 42 169 -11 21 -54 64 -39 75 27 7
43 14 46 50 23z m2440 -158 c144 -39 321 -146 715 -436 208 -153 257 -187 419
-289 126 -79 252 -174 326 -247 l49 -47 -27 -21 c-14 -12 -53 -32 -86 -45 -32
-13 -76 -37 -96 -54 -74 -60 -81 -125 -35 -317 31 -129 37 -186 20 -175 -16
10 -158 227 -175 268 -21 51 -35 38 -35 -31 0 -31 -5 -64 -10 -72 -8 -13 -13
-13 -37 2 -57 34 -65 63 -64 232 1 124 -1 156 -13 165 -13 11 -19 7 -36 -21
-11 -18 -20 -36 -20 -40 0 -19 -31 -5 -54 24 -14 18 -28 29 -32 25 -4 -4 -10
-43 -13 -86 -7 -85 -11 -97 -35 -88 -23 9 -37 72 -43 200 -3 64 -9 117 -14
117 -4 0 -17 -26 -29 -57 -24 -64 -36 -83 -55 -83 -26 0 -38 58 -31 151 5 70
4 90 -5 87 -31 -10 -52 -59 -62 -142 -6 -47 -15 -86 -19 -86 -4 0 -8 6 -8 14
0 21 -58 66 -85 66 -13 0 -37 11 -52 24 -24 21 -28 31 -27 78 0 57 11 87 46
131 19 24 20 29 8 38 -19 12 -62 2 -77 -18 -7 -9 -15 -36 -18 -62 -11 -84 -17
-102 -32 -108 -22 -9 -39 19 -47 77 -8 57 -30 87 -52 69 -11 -9 -13 -27 -8
-75 6 -54 4 -65 -10 -70 -37 -14 -41 10 -41 223 0 151 -3 207 -12 210 -12 4
-22 -26 -43 -131 -13 -64 -47 -110 -74 -100 -43 17 -41 167 4 265 11 24 20 54
20 67 0 31 -27 39 -50 16 -21 -21 -50 -120 -50 -170 0 -17 -8 -42 -18 -54 -16
-20 -19 -21 -31 -6 -8 10 -19 67 -26 140 -7 68 -15 128 -19 135 -23 36 -47
-11 -57 -111 -9 -93 -16 -118 -33 -118 -22 0 -38 51 -47 155 -13 135 -13 136
-33 90 -37 -84 -84 -108 -111 -55 -20 39 -19 79 5 117 27 45 73 65 165 72 l80
6 0 42 c0 30 7 49 25 68 49 54 112 66 205 41z m1589 -406 c14 -5 26 -14 26
-20 0 -20 -56 -31 -225 -46 -93 -8 -182 -19 -197 -23 -30 -10 -66 8 -54 27 11
18 94 39 197 51 52 6 108 13 124 15 62 7 105 6 129 -4z m-2143 -120 c25 -14
24 -37 -3 -51 -24 -13 -172 -18 -184 -6 -21 20 71 66 134 67 18 0 42 -5 53
-10z m178 -149 c32 -19 -21 -26 -199 -29 -194 -3 -218 6 -70 27 47 6 96 13
110 15 34 6 141 -4 159 -13z m201 -128 c50 -17 82 -44 68 -58 -19 -20 -189
-29 -545 -29 -352 -1 -394 1 -409 16 -15 15 -15 17 7 31 90 56 743 86 879 40z
m241 -162 c19 -6 45 -22 58 -34 36 -40 12 -48 -171 -58 -324 -17 -1165 -6
-1220 16 -56 22 14 50 162 65 275 28 1092 36 1171 11z m207 -151 c93 -10 137
-25 162 -55 31 -38 7 -40 -443 -41 -423 -1 -561 -7 -572 -24 -8 -13 33 -36 80
-46 22 -5 279 -9 570 -9 503 0 608 -5 530 -27 -34 -9 -149 -14 -610 -29 -530
-16 -1229 -56 -1480 -85 -333 -38 -408 -45 -462 -42 -49 3 -58 6 -58 22 0 49
289 95 850 136 382 28 557 75 305 82 -58 1 -252 -1 -431 -6 -221 -6 -331 -6
-344 1 -18 10 -17 11 1 21 64 34 472 82 869 101 235 12 925 12 1033 1z m1287
-44 c19 -9 114 -92 215 -192 207 -204 233 -243 234 -351 1 -56 -2 -67 -23 -84
-81 -66 -393 50 -563 209 -155 145 -132 350 48 416 50 19 48 19 89 2z m-4019
-180 c8 -32 2 -58 -13 -64 -9 -2 -13 10 -13 42 0 49 16 62 26 22z m3184 -79
c77 -15 145 -46 145 -66 0 -26 -55 -32 -360 -41 -165 -5 -334 -12 -375 -16
-64 -5 -71 -8 -50 -17 15 -6 209 -12 480 -16 447 -6 456 -7 507 -30 28 -12 61
-33 73 -46 20 -21 20 -23 3 -29 -10 -4 -98 -12 -195 -18 -98 -6 -177 -13 -175
-14 1 -1 90 -12 197 -23 231 -25 374 -49 398 -68 16 -12 15 -14 -6 -33 -35
-29 -97 -43 -135 -31 -57 19 -544 38 -1537 60 -348 8 -420 15 -420 40 0 19
111 32 337 41 230 8 301 19 238 37 -48 13 -414 7 -625 -11 -918 -78 -1129
-102 -1294 -147 -99 -27 -265 -42 -388 -36 -154 8 -191 35 -92 69 61 20 523
90 779 118 105 11 253 27 330 35 155 17 276 43 283 63 6 18 -118 16 -407 -8
-317 -26 -611 -37 -611 -23 0 14 19 21 101 38 263 56 1006 117 1634 135 573
16 926 31 975 39 67 12 118 12 190 -2z"/>
                <path d="M1292 4643 c-18 -7 -43 -59 -36 -77 9 -23 35 -28 55 -10 33 30 18
100 -19 87z"/>
                <path d="M1415 3567 c-9 -33 2 -80 15 -72 13 8 13 65 1 84 -8 12 -11 9 -16
-12z"/>
                <path d="M2281 2206 c-14 -15 -25 -42 -28 -69 -11 -91 75 -214 113 -163 17 24
28 114 19 168 -14 86 -58 113 -104 64z"/>
                <path d="M4335 693 c-127 -6 -310 -25 -325 -33 -20 -13 284 -12 470 0 229 15
290 22 284 31 -5 8 -279 10 -429 2z"/>
                <path d="M5530 571 c0 -17 107 -63 137 -59 39 4 42 33 4 52 -32 17 -141 22
-141 7z"/>
                <path d="M3821 12014 c-85 -71 -245 -384 -213 -416 12 -12 43 33 137 197 27
48 75 115 107 150 32 35 58 70 58 79 0 26 -54 20 -89 -10z"/>
                <path d="M4039 11950 c-71 -37 -340 -393 -316 -417 3 -2 29 24 58 58 164 190
195 223 243 261 104 83 113 150 15 98z"/>
                <path d="M3992 11684 c-87 -87 -127 -148 -138 -209 -3 -22 -5 -38 -2 -35 33
36 229 312 224 317 -3 3 -41 -30 -84 -73z"/>
                <path d="M5495 11639 c-130 -18 -240 -49 -341 -99 -228 -111 -437 -312 -511
-490 -21 -50 -31 -120 -18 -120 25 0 90 55 239 199 278 270 380 325 646 352
299 30 655 -37 848 -158 69 -44 99 -76 127 -139 12 -27 47 -78 78 -112 68 -77
122 -186 211 -427 37 -99 71 -187 76 -195 34 -55 45 147 16 305 -50 271 -140
449 -311 620 -126 126 -279 208 -459 247 -106 23 -481 34 -601 17z"/>
                <path d="M3589 11495 c-11 -26 -19 -49 -16 -51 7 -8 68 67 64 79 -9 27 -29 15
-48 -28z"/>
                <path d="M4395 11452 c-49 -31 -146 -144 -199 -233 -84 -141 -134 -295 -116
-358 7 -24 8 -23 19 19 61 233 201 453 337 530 56 31 65 44 38 54 -26 10 -48
7 -79 -12z"/>
                <path d="M4413 11245 c-97 -98 -167 -205 -134 -205 15 0 160 159 187 206 44
75 21 74 -53 -1z"/>
                <path d="M4346 10745 c-8 -22 28 -55 53 -48 27 7 27 28 -1 47 -28 20 -44 20
-52 1z"/>
                <path d="M3979 10673 c-76 -70 -179 -198 -179 -221 0 -17 6 -12 183 182 98
106 95 130 -4 39z"/>
                <path d="M3575 10638 c-51 -60 -101 -144 -129 -219 -56 -150 -86 -379 -66
-504 11 -71 65 -204 77 -191 4 4 10 134 13 289 8 317 12 342 100 516 37 74 61
151 47 151 -3 0 -22 -19 -42 -42z"/>
                <path d="M4225 10651 c-114 -66 -147 -146 -39 -95 33 16 114 98 114 115 0 16
-24 9 -75 -20z"/>
                <path d="M4204 10450 c-23 -16 -53 -46 -67 -67 -76 -111 -137 -334 -137 -504
0 -100 38 -232 55 -188 3 8 9 100 14 204 13 258 45 365 146 494 41 52 57 91
37 91 -4 0 -26 -13 -48 -30z"/>
                <path d="M3605 10338 c-4 -20 -3 -44 3 -54 9 -16 10 -16 21 4 9 16 8 29 -3 54
l-13 33 -8 -37z"/>
                <path d="M3718 10303 c-30 -52 -51 -204 -29 -217 16 -10 53 96 58 170 6 79 -2
92 -29 47z"/>
                <path d="M4835 10214 c-133 -31 -190 -59 -304 -144 -168 -127 -396 -430 -481
-639 -16 -38 -47 -98 -70 -133 -22 -35 -47 -85 -56 -113 -40 -136 -86 -426
-144 -910 -43 -363 -77 -575 -116 -714 -66 -234 -75 -301 -41 -301 17 0 61 80
77 140 13 50 45 116 90 187 89 141 221 575 240 791 10 110 26 162 50 162 24 0
29 -71 16 -265 -6 -99 -5 -127 4 -119 18 18 38 110 49 225 12 124 33 189 63
189 31 0 49 -60 57 -202 8 -122 15 -158 25 -127 2 8 10 31 16 52 14 45 23 40
39 -25 39 -163 -50 -566 -190 -852 -22 -43 -39 -81 -39 -84 0 -3 11 5 25 18
43 40 90 120 129 217 29 74 116 358 151 498 l8 30 8 -30 c5 -16 10 -75 10
-130 1 -85 -3 -113 -29 -190 -76 -233 -338 -752 -453 -896 -30 -38 -38 -69
-18 -69 45 0 319 403 319 469 0 10 24 54 54 98 66 97 95 154 130 253 49 134
76 268 86 424 16 230 92 642 157 851 58 186 177 338 318 406 l70 34 -44 3
c-70 5 -140 -36 -251 -147 -137 -138 -185 -236 -234 -486 -35 -173 -53 -210
-83 -169 -18 23 -12 84 23 265 31 159 77 324 115 410 32 73 36 93 17 87 -37
-13 -152 -312 -163 -424 -4 -32 -11 -71 -17 -86 -13 -36 -45 -37 -54 -2 -17
65 33 309 95 470 59 152 103 193 334 309 167 83 287 127 351 127 57 0 164 -50
224 -106 61 -56 82 -104 82 -192 0 -39 3 -86 7 -104 6 -32 7 -31 39 46 60 143
41 279 -54 377 -62 65 -103 80 -197 74 -92 -6 -278 -59 -393 -113 -167 -77
-328 -210 -419 -347 -56 -84 -94 -174 -125 -292 l-23 -90 -5 102 c-6 119 -15
135 -59 104 -18 -13 -32 -17 -36 -11 -3 5 6 69 21 142 31 149 29 173 -11 158
-39 -15 -75 -12 -75 5 0 23 91 192 150 281 121 180 241 304 340 351 86 41 221
60 319 46 97 -15 131 -31 196 -93 47 -46 62 -54 93 -51 23 2 12 48 -23 93 -39
52 -113 109 -177 137 -42 19 -173 34 -213 25z m-853 -1416 c-17 -307 -39 -551
-62 -691 -24 -145 -55 -211 -74 -161 -25 65 27 656 83 939 24 126 38 162 53
147 9 -9 9 -65 0 -234z"/>
                <path d="M3564 10165 c-43 -104 -46 -308 -5 -402 13 -29 30 -58 38 -64 29 -25
32 6 12 101 -15 72 -20 132 -20 248 0 83 -2 152 -5 152 -3 0 -12 -16 -20 -35z"/>
                <path d="M3841 10075 c-2 -29 22 -261 34 -333 14 -81 46 -166 79 -207 15 -20
15 -20 16 3 0 12 -13 68 -30 123 -16 55 -43 168 -60 252 -31 153 -38 181 -39
162z"/>
                <path d="M4769 9986 c-113 -46 -211 -118 -325 -239 -72 -76 -165 -219 -151
-233 2 -3 54 53 115 123 200 232 227 251 404 289 62 13 119 31 127 39 15 15
14 18 -3 31 -29 21 -103 17 -167 -10z"/>
                <path d="M3695 9895 c8 -113 24 -234 36 -273 11 -35 39 -55 63 -46 28 11 25
34 -15 111 -24 48 -49 119 -64 183 l-25 105 5 -80z"/>
                <path d="M4835 9826 c-145 -45 -491 -377 -521 -498 -11 -49 12 -31 89 65 98
122 238 254 313 294 34 18 97 41 140 52 99 24 126 34 144 56 12 15 12 19 -5
31 -23 17 -106 17 -160 0z"/>
                <path d="M4825 9431 c-88 -51 -148 -127 -80 -101 70 26 145 86 145 114 0 22
-7 20 -65 -13z"/>
                <path d="M2555 9346 c-98 -31 -140 -70 -175 -163 -42 -110 -80 -248 -96 -350
-20 -117 -11 -204 26 -276 28 -55 72 -101 81 -86 7 11 0 42 -40 193 -59 220 2
399 211 623 44 48 59 74 41 72 -5 0 -26 -6 -48 -13z"/>
                <path d="M2534 9129 l-29 -32 30 7 c36 9 75 33 75 46 0 22 -48 8 -76 -21z"/>
                <path d="M7678 9070 c-43 -11 -99 -31 -126 -44 -67 -34 -143 -120 -192 -217
-74 -149 -45 -159 80 -26 142 149 260 206 427 207 139 0 250 -50 307 -137 13
-21 40 -64 61 -97 47 -76 62 -65 40 33 -30 128 -121 231 -245 277 -71 26 -256
28 -352 4z"/>
                <path d="M2446 9034 c-23 -22 -22 -112 1 -121 38 -15 74 92 41 125 -16 16 -23
15 -42 -4z"/>
                <path d="M2442 8648 c-18 -18 -14 -54 12 -107 36 -70 75 -113 100 -109 18 3
21 10 21 47 0 39 -4 46 -30 61 -21 12 -32 28 -40 59 -13 53 -39 73 -63 49z"/>
                <path d="M7735 8641 c-12 -5 -38 -21 -59 -35 -22 -14 -53 -26 -70 -26 -88 -1
-301 -156 -282 -205 16 -44 98 -38 115 9 12 30 52 59 136 97 124 56 239 70
403 49 149 -19 230 -83 315 -247 63 -122 77 -176 87 -341 9 -133 19 -182 39
-182 25 0 61 148 61 250 0 159 -70 388 -143 467 -48 52 -169 115 -277 144 -82
22 -291 35 -325 20z"/>
                <path d="M7044 8518 c-59 -81 -86 -134 -82 -161 4 -20 7 -19 45 20 44 45 97
131 108 176 12 48 -22 32 -71 -35z"/>
                <path d="M7246 8265 c-8 -30 0 -65 15 -65 9 0 13 20 9 55 -3 33 -17 38 -24 10z"/>
                <path d="M6230 7998 c0 -94 14 -211 45 -368 48 -245 126 -696 134 -778 5 -46
11 -85 14 -88 12 -13 22 101 21 256 0 198 -8 248 -109 655 -41 165 -77 319
-81 343 -11 69 -24 59 -24 -20z"/>
                <path d="M4228 8009 c-21 -45 -118 -319 -118 -335 0 -2 4 -4 8 -4 27 0 145
304 140 360 l-4 35 -26 -56z"/>
                <path d="M7395 7980 c-241 -38 -419 -155 -513 -336 -86 -168 -143 -389 -119
-462 27 -82 65 -31 96 131 29 145 70 232 155 324 109 117 232 185 396 219 158
32 291 4 456 -96 142 -85 177 -79 113 21 -60 94 -143 149 -274 184 -75 20
-230 27 -310 15z"/>
                <path d="M1493 7807 c-26 -29 -73 -91 -104 -138 -112 -167 -182 -344 -102
-256 19 20 156 230 240 366 58 95 40 109 -34 28z"/>
                <path d="M1777 7543 c-45 -50 -89 -232 -85 -348 2 -44 6 -73 10 -65 3 8 29 94
57 190 61 210 67 276 18 223z"/>
                <path d="M3867 7531 c-60 -72 -174 -281 -226 -416 -36 -95 -56 -125 -80 -125
-30 0 -41 -23 -61 -122 -29 -145 -41 -311 -41 -583 0 -243 12 -384 41 -486 13
-45 55 -88 72 -71 8 8 6 30 -10 89 -32 119 -45 265 -45 523 l0 235 37 144 c21
79 51 183 68 230 36 105 154 352 198 415 41 61 82 154 78 179 -3 19 -6 18 -31
-12z"/>
                <path d="M1643 7487 c-52 -59 -101 -298 -90 -435 9 -111 29 -95 47 37 24 178
51 328 66 374 9 27 14 50 11 53 -2 3 -18 -11 -34 -29z"/>
                <path d="M8260 7509 c-14 -5 -36 -20 -49 -32 -30 -29 -104 -137 -98 -144 3 -3
59 3 124 12 157 22 178 17 278 -76 41 -40 87 -92 102 -116 23 -39 25 -52 20
-111 -5 -76 -59 -245 -117 -370 -94 -200 -259 -430 -444 -618 -146 -147 -242
-219 -406 -304 -126 -65 -227 -145 -218 -172 8 -23 50 -8 126 43 82 55 141 87
255 135 158 66 392 247 427 329 18 43 82 124 183 235 165 180 232 350 271 685
17 148 12 186 -30 247 -41 59 -195 200 -253 231 -56 31 -133 43 -171 26z"/>
                <path d="M7496 7357 c-82 -83 -110 -135 -125 -227 -12 -69 -24 -313 -41 -800
-6 -162 -17 -349 -25 -415 -8 -66 -15 -130 -15 -142 0 -73 61 40 85 154 26
128 38 294 65 893 12 257 24 377 45 427 7 17 41 58 74 91 67 64 77 92 35 92
-20 0 -45 -19 -98 -73z"/>
                <path d="M3457 7331 c-31 -38 -83 -160 -108 -258 -20 -79 -26 -193 -10 -193
18 0 158 362 168 435 7 55 -12 61 -50 16z"/>
                <path d="M3941 7080 c-33 -41 -64 -52 -75 -25 -15 40 -69 -15 -130 -135 -55
-108 -83 -189 -107 -315 -36 -182 -36 -375 -1 -309 5 10 22 73 37 139 49 220
75 284 186 453 71 107 134 221 126 228 -2 2 -18 -14 -36 -36z"/>
                <path d="M7574 7093 c-8 -18 -24 -803 -16 -813 7 -9 32 33 42 70 35 130 38
636 4 742 -7 23 -20 23 -30 1z"/>
                <path d="M3185 6893 c-56 -83 -116 -346 -130 -568 -17 -292 44 -694 128 -833
40 -67 93 -126 106 -118 12 8 -9 81 -48 168 -83 187 -106 313 -106 593 0 250
12 337 76 570 45 160 50 225 19 225 -11 0 -30 -16 -45 -37z"/>
                <path d="M7136 6807 c-14 -14 -28 -46 -35 -76 -14 -65 -14 -350 -1 -756 6
-170 15 -517 20 -770 9 -410 16 -524 33 -542 16 -15 32 102 47 342 15 230 30
290 109 434 17 30 29 56 27 58 -2 2 -15 -2 -30 -8 -54 -25 -85 41 -111 231
-17 121 -19 500 -6 820 12 276 3 323 -53 267z"/>
                <path d="M6455 6572 c-30 -46 -45 -107 -24 -100 14 5 52 73 64 116 10 35 -12
26 -40 -16z"/>
                <path d="M5436 6258 c-31 -55 -39 -85 -27 -93 30 -18 71 43 71 106 0 41 -15
36 -44 -13z"/>
                <path d="M6766 6173 c-44 -138 -67 -439 -91 -1208 -23 -739 -37 -907 -90
-1102 -83 -305 -196 -526 -317 -625 -24 -19 -72 -52 -108 -72 -77 -45 -120
-83 -120 -107 0 -27 48 -9 143 55 294 196 443 458 507 896 45 308 70 719 100
1655 12 386 13 555 1 555 -5 0 -16 -21 -25 -47z"/>
                <path d="M7512 6153 c-38 -54 -79 -178 -62 -188 12 -7 45 43 68 101 40 102 37
147 -6 87z"/>
                <path d="M3308 6065 c-39 -117 3 -406 61 -423 17 -6 12 43 -18 155 -12 46 -26
129 -30 185 -3 57 -10 94 -13 83z"/>
                <path d="M2519 6046 c-57 -39 -69 -88 -90 -364 -13 -174 -7 -716 9 -774 5 -21
21 -51 35 -67 14 -17 39 -74 56 -128 23 -74 40 -110 72 -148 22 -27 54 -75 70
-107 77 -152 63 -38 -31 247 -85 258 -100 372 -100 757 0 290 10 415 40 516
29 94 10 116 -61 68z"/>
                <path d="M6083 5938 c-6 -7 -13 -31 -16 -53 -15 -98 -192 -405 -301 -524 -59
-64 -86 -108 -86 -141 0 -27 8 -25 63 11 63 41 198 187 257 277 67 103 112
241 114 351 1 83 -9 107 -31 79z"/>
                <path d="M6975 5550 c-9 -39 3 -98 16 -79 12 19 11 96 0 103 -5 4 -12 -7 -16
-24z"/>
                <path d="M4627 4953 c-9 -8 -9 -56 -1 -77 10 -25 24 -8 24 27 0 35 -12 61 -23
50z"/>
                <path d="M3241 4861 c-12 -16 -38 -64 -58 -107 -46 -98 -53 -159 -25 -251 34
-114 56 -285 72 -568 26 -453 40 -611 57 -639 18 -28 26 78 30 387 5 351 -6
604 -33 743 -19 101 -18 207 3 330 9 55 14 108 10 117 -10 26 -33 20 -56 -12z"/>
                <path d="M7126 4548 c-6 -70 4 -171 18 -185 15 -16 26 26 26 102 0 81 -14 155
-29 155 -5 0 -12 -33 -15 -72z"/>
                <path d="M7109 4294 c-16 -20 -27 -234 -12 -234 10 0 46 109 59 176 6 31 -9
74 -25 74 -5 0 -15 -7 -22 -16z"/>
                <path d="M6427 4095 c-10 -179 -40 -292 -115 -440 -54 -108 -110 -181 -230
-303 -95 -96 -124 -142 -88 -142 41 0 210 155 306 282 118 155 154 267 152
468 -1 74 -5 160 -10 190 -8 53 -8 51 -15 -55z"/>
                <path d="M3479 4104 c-28 -45 -39 -134 -17 -134 31 0 52 39 56 106 5 74 -6 81
-39 28z"/>
                <path d="M4280 3932 c0 -106 3 -161 10 -157 13 8 13 285 0 305 -6 10 -10 -39
-10 -148z"/>
                <path d="M3470 3855 c-29 -67 -89 -286 -97 -355 l-6 -55 24 16 c53 35 100 175
114 339 8 100 -6 122 -35 55z"/>
                <path d="M4610 3800 c0 -23 7 -70 16 -104 37 -146 34 -139 51 -124 22 18 12
128 -19 204 -29 72 -48 82 -48 24z"/>
                <path d="M2653 3741 c-85 -114 -94 -235 -30 -423 72 -213 158 -354 246 -402
45 -24 61 -28 107 -24 87 7 85 19 -8 81 -245 163 -329 356 -287 664 6 44 9 95
7 114 l-3 34 -32 -44z"/>
                <path d="M6916 3597 c-49 -65 -86 -177 -57 -177 30 0 100 123 101 178 0 41
-12 41 -44 -1z"/>
                <path d="M4702 3483 c2 -23 8 -29 36 -31 39 -4 44 18 10 42 -34 24 -50 20 -46
-11z"/>
                <path d="M550 1764 c-288 -44 -497 -90 -536 -119 -17 -12 -17 -15 -4 -29 13
-13 28 -13 130 5 239 41 585 131 615 160 14 13 -30 10 -205 -17z"/>
                <path d="M8930 1470 c-10 -7 11 -10 68 -10 53 0 81 4 77 10 -8 13 -125 13
-145 0z"/>
                <path d="M7850 1310 c25 -4 153 -10 285 -14 132 -4 399 -13 594 -22 350 -14
393 -12 364 17 -6 6 -53 14 -104 19 -112 11 -1204 11 -1139 0z"/>
                <path d="M481 875 c-154 -14 -187 -27 -165 -63 26 -39 188 -13 344 57 l45 20
-40 -1 c-22 0 -105 -6 -184 -13z"/>
                <path d="M520 724 c-25 -8 -56 -23 -70 -35 l-25 -21 60 5 c58 5 175 44 175 60
0 12 -92 7 -140 -9z"/>
                <path d="M1647 643 c-37 -42 -71 -161 -58 -209 12 -47 32 -34 55 36 12 36 34
83 49 105 15 21 27 48 25 60 -4 27 -48 32 -71 8z"/>
            </g>
        </svg>

    )
}
export default SvgTrain
  